import { normalize } from 'normalizr';
import fetchService from 'common/actions/fetchService';
import updateEntities from 'common/actions/updateEntities';
import providerId from 'modules/bus/shared/selectors/userConfig/busProviderId';
import busAgentAutoCompleteSchema from '../../shared/schemas/busAgentAutoCompleteSchema';

export const BUS_AGENT_AUTO_COMPLETE_STATION_FETCH =
  'BUS/BUS_AGENT_AUTO_COMPLETE_STATION_FETCH';

export default function fetchAutoCompleteAgent(query) {
  return (dispatch, getState) => {
    const request = {
      query,
      providerId: providerId(getState()),
    };

    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetagent/search/agentList',
          request
        )
      )
    ).then(({ result }) => {
      // NB: need to be remove if backend support result by query
      const filteredResult = result.data.agents.filter(
        agent => agent.agentUserName.indexOf(query) >= 0
      );

      const { entities, result: entityIds } = normalize(filteredResult, [
        busAgentAutoCompleteSchema,
      ]);

      dispatch(updateEntities(entities));
      dispatch({
        type: BUS_AGENT_AUTO_COMPLETE_STATION_FETCH,
        payload: entityIds,
      });
    });
  };
}
